// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_2QKsa{width:100%}.item_3VLbZ{display:none}.item_3VLbZ.selected_2KFER{display:block}", ""]);
// Exports
exports.locals = {
	"container": "container_2QKsa",
	"item": "item_3VLbZ",
	"selected": "selected_2KFER"
};
module.exports = exports;
